"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../Schema/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const GeopointField = props => {
  const registry = props.registry,
        schema = props.schema,
        uiSchema = props.uiSchema,
        formData = props.formData;
  const ObjectField = registry.fields.ObjectField;

  const handleChange = formData => {
    const newFormData = (0, _utils.getDefaultFormState)(schema, formData);
    console.log('GeopointField:onChange', newFormData);

    if (props.onChange) {
      props.onChange(newFormData);
    }
  };

  const newUiSchema = _extends({}, uiSchema, {
    "ui:location": formData || {},
    "ui:onChange": handleChange
  });

  return _react.default.createElement(ObjectField, _extends({}, props, {
    onChange: handleChange,
    uiSchema: newUiSchema
  }));
};

var _default = GeopointField;
exports.default = _default;
module.exports = exports.default;